import toast, { Toaster } from 'react-hot-toast';
import {
  useVoteRecorded,
  useElectionCreated,
  useElectionStatusChanged,
  useTallyingStarted,
  useTallyingCompleted,
} from '../hooks/useWebSocket';

/**
 * NotificationListener component
 * Listens to WebSocket events and displays toast notifications
 */
export function NotificationListener() {
  // Listen to vote recorded events
  useVoteRecorded((data) => {
    toast.success(
      <div>
        <strong>Vote Recorded</strong>
        <p className="text-sm">{data.message}</p>
        {data.blockNumber && <p className="text-xs text-gray-500">Block #{data.blockNumber}</p>}
      </div>,
      {
        duration: 4000,
        position: 'top-right',
        icon: '📝',
      }
    );
  });

  // Listen to election created events
  useElectionCreated((data) => {
    toast.success(
      <div>
        <strong>New Election</strong>
        <p className="text-sm">{data.message}</p>
        <p className="text-xs text-gray-500">{data.title}</p>
      </div>,
      {
        duration: 5000,
        position: 'top-right',
        icon: '🗳️',
      }
    );
  });

  // Listen to election status changed events
  useElectionStatusChanged((data) => {
    const icon = data.newStatus === 'ACTIVE' ? '▶️' : data.newStatus === 'CLOSED' ? '⏹️' : '⏸️';

    toast(
      <div>
        <strong>Election Status Changed</strong>
        <p className="text-sm">{data.message}</p>
        <p className="text-xs text-gray-500">
          {data.oldStatus} → {data.newStatus}
        </p>
      </div>,
      {
        duration: 4000,
        position: 'top-right',
        icon,
      }
    );
  });

  // Listen to tallying started events
  useTallyingStarted((data) => {
    toast(
      <div>
        <strong>Vote Counting Started</strong>
        <p className="text-sm">{data.message}</p>
        <p className="text-xs text-gray-500">Total votes: {data.totalVotesCast}</p>
      </div>,
      {
        duration: 5000,
        position: 'top-right',
        icon: '🔢',
      }
    );
  });

  // Listen to tallying completed events
  useTallyingCompleted((data) => {
    toast.success(
      <div>
        <strong>Vote Counting Completed</strong>
        <p className="text-sm">{data.message}</p>
        <p className="text-xs text-gray-500">Total votes: {data.totalVotesCast}</p>
      </div>,
      {
        duration: 6000,
        position: 'top-right',
        icon: '✅',
      }
    );
  });

  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        className: '',
        duration: 4000,
        style: {
          background: '#363636',
          color: '#fff',
        },
        success: {
          duration: 4000,
          style: {
            background: '#10b981',
            color: '#fff',
          },
        },
        error: {
          duration: 5000,
          style: {
            background: '#ef4444',
            color: '#fff',
          },
        },
      }}
    />
  );
}
